import React from 'react';
import FieldShell from './FieldShell';
import { useDraftField } from '../hooks/useDraftField';
import { useFieldLifecycle } from '../hooks/useFieldLifecycle';

export function formatCommaList(value = []) {
  return (value || []).join(', ');
}

export function parseCommaList(value = '') {
  return value
    .split(',')
    .map((entry) => entry.trim())
    .filter(Boolean);
}

export default function CommaListField({
  value,
  onChange,
  label,
  helpText,
  error,
  inputId,
  width,
  tapTarget,
  startAdornment,
  endAdornment,
  onBlur,
  onKeyDown,
  cancelOnEscape = false,
  blurAfterCancel = false,
  flushOnBlur = true,
  unmountPolicy = 'cancel',
  ...rest
}) {
  const { draft, cancel, flush, updateDraft } = useDraftField({
    value,
    onCommit: (nextDraft) => onChange(parseCommaList(nextDraft)),
    format: formatCommaList,
    unmountPolicy,
  });
  const { handleBlur, handleKeyDown } = useFieldLifecycle({
    flush,
    cancel,
    onBlur,
    onKeyDown,
    flushOnBlur,
    cancelOnEscape,
    submitOnEnter: true,
    blurAfterSubmit: true,
    blurAfterCancel,
  });

  const control = (
    <input
      {...rest}
      value={draft}
      onBlur={handleBlur}
      onChange={(event) => updateDraft(event.target.value)}
      onKeyDown={handleKeyDown}
    />
  );

  const shouldWrapWithShell = !!(label || helpText || error || inputId || width || tapTarget || startAdornment || endAdornment);
  if (!shouldWrapWithShell) {
    return control;
  }

  return (
    <FieldShell
      label={label}
      helpText={helpText}
      error={error}
      inputId={inputId}
      width={width}
      tapTarget={tapTarget}
      startAdornment={startAdornment}
      endAdornment={endAdornment}
    >
      {control}
    </FieldShell>
  );
}
